/* eslint-disable camelcase */
import { useActivePlotGroup } from '@/components/PlotGroups/PlotGroupsContextProvider';
import { isNullish } from '@/utils/booleans';

export const useHideTrendFacts = () => {
  const { filters } = useActivePlotGroup();

  const { start_date, end_date } = filters;

  return !isNullish(start_date) || !isNullish(end_date);
};
